/* tslint:disable: variable-name */
/* Must directly match with the case-sensitive data returned from the API. */

import { ProcessProviderId } from './process-provider-id';
import { MarketplaceItemStockType } from './marketplace-item-stock-type.model';
import { MarketplaceItemAttribute } from './attributes/marketplace-item-attribute.model';
import { MarketplaceItemMappingAttribute } from './attributes/marketplace-item-mapping-attribute.model';
import { MarketplaceCustomFieldModel } from './marketplace-custom-field.model';
import { Sponsor } from '../../shared/models/sponsor.model';

export class MarketplaceItem {
  Id: number;
  ClubId: number;
  GameNumber: number;
  PointValue: number;
  EcashValue: number;
  MerchantValue: number;
  ProductItemId: number;
  Active: boolean;
  StockCount: number;
  UnlimitedStock: boolean;
  AllowOne: boolean;
  TestOnly: boolean;
  Favourite: boolean;
  ComingSoon: boolean;
  ItemLimitCount: number;
  ItemLimitType: MarketplaceItemLimitType;
  LimitCount: number;
  LimitType: MarketplaceItemLimitType;
  IsOwnWindow: boolean;
  ItemStartDate: Date | string;
  ItemEndDate: Date | string;
  SoldCount: number;
  AvailabilityCount: number;
  AvailableCount: number;
  MaxQuantity: number;
  DisplayName: string;
  DescriptionText: string;
  ShortDescription: string;
  TermsAndConditions: string;
  ShowTermsAndConditions: boolean;
  TermsAndConditionsType: number;
  ProductName: string;
  ImageURL: string;
  ThumbnailURL: string;
  ItemImageURL: string;
  ItemThumbnailURL: string;
  ProductType: number;
  ItemPopulationType: number;
  AddedAdminId: number;
  UpdatedAdminId: number;
  Ordinal: number;
  EmailText: string;
  PurchaseAllowed: boolean;
  MemberPurchaseCount: number;
  AccountPurchaseCount: number;
  ProcessProviderId: ProcessProviderId;
  NumberOfAvailableVouchers: number | null;
  EmailCategoryId: number;
  ShippingEnabled: number;
  ShippingMethods: number[];
  ShippingFeeInMerchant: number;
  ShippingFeeInEcash: number;
  ExpiresAfter: number | null;
  ExpirationEndDate: Date | string | null;
  RequestTime: Date | string;
  IsAdminUser: boolean;
  StockType: MarketplaceItemStockType;
  Attributes: MarketplaceItemAttribute[];
  AttributeMappings: MarketplaceItemMappingAttribute[];
  theme: string;
  CustomFields: MarketplaceCustomFieldModel[];
  Sponsor: Sponsor;
  Locked?: boolean;
}

export enum MarketplaceItemLimitType {
  NoLimit = 0,
  LimitByMember = 1,
  LimitByAccount = 2,
}
